/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Report-chart': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M17.583.25H2.417A2.173 2.173 0 00.25 2.417v15.166c0 1.192.975 2.167 2.167 2.167h15.166a2.173 2.173 0 002.167-2.167V2.417A2.173 2.173 0 0017.583.25zM6.75 15.417H4.583V7.833H6.75v7.584zm4.333 0H8.917V4.583h2.166v10.834zm4.334 0H13.25v-4.334h2.167v4.334z" _fill="#9BC225"/>'
  }
})
